if (!customElements.get('cart-shipping-confirmation')) {
  customElements.define('cart-shipping-confirmation', class extends HTMLElement {
    connectedCallback() {
      if (this.config) return;
      this.config = JSON.parse(this.querySelector('[data-shipping-confirmation-config]').textContent);
      this.update(Number(this.dataset.total));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.request?.abort();
      this.config = null;
    }
    update(total) {
      const state = window.PetsUpsellOffers?.shipping(this.config, total, window.Shopify?.currency);
      this.hidden = !state?.unlocked || total <= 0 || !this.querySelector('strong').textContent.trim();
    }
    async refresh() {
      this.request?.abort();
      const request = this.request = new AbortController();
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { signal: request.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (request.signal.aborted || !this.isConnected) return;
        if (cart.currency !== this.config.currency) { this.hidden = true; return; }
        this.update(cart.total_price);
      } catch (error) {
        if (!request.signal.aborted) this.hidden = true;
      }
    }
  });
}
